export const ROUTE_PATHS = {
    PUBLIC: {
        MAIN: "/",
        REGISTRATION: "/registration"
    },
    PRIVATE: {

    }
}
